import { render, staticRenderFns } from "./EntregaDetalhar.vue?vue&type=template&id=3e97b66e"
import script from "./EntregaDetalhar.vue?vue&type=script&lang=js"
export * from "./EntregaDetalhar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports